import '../App.css';

function ErasTourPrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="app-name">Eras Tour: Find Surprise Songs</p>
        <p className="last-updated">Last Updated: January 2025</p>

        <section>
          <h2>Introduction</h2>
          <p>
            This Privacy Policy explains how Eras Tour Surprise Songs ("the App") collects,
            uses, and protects your information. By using the App, you agree to the terms
            outlined in this policy.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <h3>Information You Provide</h3>
          <ul>
            <li>Favorite songs you save within the App</li>
            <li>Search queries and filter preferences</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <ul>
            <li>Device information (device type, operating system version)</li>
            <li>App usage analytics (screens viewed, features used)</li>
            <li>Crash reports and performance data</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Provide and improve the App's functionality</li>
            <li>Remember your preferences and favorites locally on your device</li>
            <li>Analyze usage patterns to improve user experience</li>
            <li>Fix bugs and improve App performance</li>
          </ul>
        </section>

        <section>
          <h2>Data Storage</h2>
          <p>
            Your favorites and preferences are stored locally on your device using secure
            storage mechanisms. We do not store personal data on external servers.
          </p>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          <p>The App may use third-party services for:</p>
          <ul>
            <li>Analytics (to understand App usage)</li>
            <li>Advertising (to support free access to the App)</li>
          </ul>
          <p>
            These third-party services may collect information in accordance with their
            own privacy policies.
          </p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>
            The App is not directed at children under 13. We do not knowingly collect
            personal information from children under 13.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of
            any changes by posting the new Privacy Policy within the App.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at:{' '}
            <a href="mailto:hello@durianbit.com">hello@durianbit.com</a>
          </p>
        </section>

        <section className="disclaimer">
          <h2>Disclaimer</h2>
          <p>
            <strong>
              This app is not affiliated with, endorsed by, or associated with Taylor Swift,
              TAS Rights Management, LLC, or the Eras Tour in any way.
            </strong>{' '}
            All song information and tour data is compiled from publicly available sources
            for informational purposes only. Taylor Swift, The Eras Tour, and related marks
            are trademarks of their respective owners. YouTube is a trademark of Google LLC.
          </p>
        </section>
      </div>
    </div>
  );
}

export default ErasTourPrivacyPolicy;
